<section class="business-registration-ads-9-company">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <div class="title"
          ><span>{{ 'BUSINESS_REGISTRATION_ADS.9_COMPANY.TITLE' | translate }}</span></div
        >
        <div class="detail"
          ><span>{{ 'BUSINESS_REGISTRATION_ADS.9_COMPANY.DETAIL' | translate }}</span></div
        >
      </div>

      <div class="box__right">
        <div class="box__card">
          <ng-container *ngFor="let item of loopArray(9); let i = index">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span>{{ 'BUSINESS_REGISTRATION_ADS.9_COMPANY.' + (i + 1) + '.TEXT' | translate }}</span>
            </div>
          </ng-container>

          <div class="box__link">
            <a
              href="https://flowaccount.com/faq/knowledge-base/business-registration-with-flowaccount/"
              rel="nofollow noopener"
              target="_blank"
            >
              <span class="text">{{ 'BUSINESS_REGISTRATION_ADS.9_COMPANY.READ_MORE' | translate }} </span>
              <i class="fas fa-angle-right"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
